<template>
  <div>
    <div class="foot">
      <ul>
        <li :class="[childMsg === 0 ? 'on' : '']">
           <router-link :to="{path:'/index',query:{'pdk':routArg.pdk,'aspx':routArg.aspx,'source':routArg.source}}">
            <img src="@a/fot11.png" v-if="childMsg === 0">
            <img src="@a/fot1.png" v-else>
            <p>加速</p>
          </router-link>
          <!-- <a :href="getCursor+'career/index.html'">
            <img src="@a/fot11.png" v-if="childMsg === 0">
            <img src="@a/fot1.png" v-else>
            <p>加速</p>
          </a> -->
        </li>
        <li :class="[childMsg === 1 ? 'on' : '']">
          <router-link :to="{path:'/person',query:{'pdk':routArg.pdk,'aspx':routArg.aspx,'source':routArg.source}}">
            <img src="@a/fot22.png" v-if="childMsg === 1">
            <img src="@a/fot2.png" v-else>
            <p>我的</p>
          </router-link>
          <!-- <a :href="getCursor + 'career/person/person.html'">
            <img src="@a/fot22.png" v-if="childMsg === 1">
            <img src="@a/fot2.png" v-else>
            <p>我的</p>
          </a> -->
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { getCursorHash } from "@/utils/tools";
export default {
  data() {
      return {
        getCursor: ""
      };
    },
    props: ['childMsg','routArg'],
    created() {
      this.getCursor = getCursorHash()
    }
};
</script>
<style lang="scss" scoped>
@import "../style/remChange.scss";
.foot {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: changeRem(1.96) + px;
  background: rgba(245, 245, 245, 1);
  left: 50%;
  margin-left: -5rem;
  max-width: 10rem;
  ul {
    li {
      float: left;
      width: 50%;
      text-align: center;
      padding-top: changeRem(0.2) + px;
      img {
        width: changeRem(0.8) + px;
        height: changeRem(0.8) + px;
        vertical-align: middle;
      }
      p {
        font-size: changeRem(0.4) + px;
        color: #666;
        line-height: changeRem(0.8) + px;
      }
    }
    .on {
      p {
        color: #f58016;
      }
    }
  }
}
</style>
